<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-27 16:42:16
 * @LastEditors: pj
 * @LastEditTime: 2022-10-27 20:26:18
-->
<template>
    <a-select show-search v-model="currentCode" placeholder="选择平台" allow-clear style="width: 150px" :default-active-first-option="true" :filter-option="true" :not-found-content="null" @change="handleChange">
        <a-select-option v-for="d in data" :key="d.value">
            {{ d.text }}
        </a-select-option>
    </a-select>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            currentCode: '',
        }
    },
    props: {
        platformtype: String,
    },
    methods: {
        handleChange(v) {
            this.currentCode = v
            this.$emit('platformChange', v)
        },
        doSearch() {
            let that = this

            that.$store
                .dispatch({
                    type: 'filemanager/ossplatformlist',
                    params: {
                        module: 'oss',
                    },
                    showMsg: false,
                })
                .then((res) => {
                    if (res.data.success == 1) {
                        let result = res.data.data
                        if (!result) {
                            that.message.error('未查询到平台')
                            return
                        }
                        result.forEach((r) => {
                            that.data.push({
                                value: r.platformtype,
                                text: r.platformtypename,
                            })
                        })
                    }
                })
        },
    },
    mounted() {
        this.doSearch()
    },
}
</script>

<style scoped>
</style>
